import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  notifyHideChatbot,
  notifyShowChatbot,
  notifyShowPopupMessage,
} from '@/helpers/loaderAPI';

export const hideChatbotWithDelay = createAsyncThunk(
  'chatbotVisibility/hideChatbotWithDelay',
  async (delay, thunkAPI) => {
    const { startTime, secondsPassed, animTimerId } =
      thunkAPI.getState().chatbotVisibility;
    const seconds =
      (new Date().getTime() - new Date(startTime).getTime()) / 1000;
    thunkAPI.dispatch(setSecondsPassed(Math.round(secondsPassed + seconds)));
    thunkAPI.dispatch(setTransition(false));
    clearTimeout(animTimerId);
    const timerID = setTimeout(() => {
      notifyHideChatbot();
      thunkAPI.dispatch(setVisibility(false));
    }, delay? delay : 1);
    thunkAPI.dispatch(setAnimTimerID(timerID));
  }
);

export const showChatbotWithDelay = createAsyncThunk(
  'chatbotVisibility/showChatbotWithDelay',
  async (delay, thunkAPI) => {
    const { animTimerId, popupMessageTimerId } =
      thunkAPI.getState().chatbotVisibility;
    clearTimeout(animTimerId);
    clearTimeout(popupMessageTimerId);
    notifyShowChatbot();
    thunkAPI.dispatch(setIsEverOpened(true));
    thunkAPI.dispatch(setPopupMessageVisibility(false));
    thunkAPI.dispatch(setStartTime(new Date().toISOString()));
    thunkAPI.dispatch(setTransition(true));
    const timerID = setTimeout(() => {
      thunkAPI.dispatch(setVisibility(true));

      // save chatbot's last_open time to localStorage - AutoPopup Settings
      localStorage.setItem('last_open', new Date().getTime().toString());

    }, delay? delay : 1);
    thunkAPI.dispatch(setAnimTimerID(timerID));
  }
);

export const showPopupMessageWithDelay = createAsyncThunk(
  'chatbotVisibility/showPopupMessageWithDelay',
  async (delay, thunkAPI) => {
    const { popupMessageTimerId } = thunkAPI.getState().chatbotVisibility;
    const { settings } = thunkAPI.getState().chatbotDetails;
    clearTimeout(popupMessageTimerId);
    const timerID = setTimeout(() => {
      notifyShowPopupMessage(settings?.popupMessage, settings?.popupSize);
      thunkAPI.dispatch(setPopupMessageVisibility(true));
    }, delay || 2000);
    thunkAPI.dispatch(setPopupMessageTimerID(timerID));
  }
);

export const hidePopupMessage = createAsyncThunk(
  'chatbotVisibility/hidePopupMessage',
  async (action, thunkAPI) => {
    const { popupMessageTimerId } = thunkAPI.getState().chatbotVisibility;
    clearTimeout(popupMessageTimerId);
    thunkAPI.dispatch(setPopupMessageVisibility(false));
    const timerID = setTimeout(() => {
      notifyHideChatbot();
    }, 500);
    thunkAPI.dispatch(setPopupMessageTimerID(timerID));
  }
);

const chatbotVisibility = createSlice({
  name: 'chatbotVisibility',
  initialState: {
    isVisible: false,
    isEverOpened: false,
    startTime: null,
    secondsPassed: 0,
    isPopupMessageVisible: false,
    popupMessageTimerId: 0,
    animTransition: false,
    animTimerId: 0,
  },
  reducers: {
    setVisibility: (state, action) => {
      state.isVisible = action.payload;
    },
    setPopupMessageVisibility: (state, action) => {
      state.isPopupMessageVisible = action.payload;
    },
    setPopupMessageTimerID: (state, action) => {
      state.popupMessageTimerId = action.payload;
    },
    setIsEverOpened: (state, action) => {
      state.isEverOpened = action.payload;
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload;
    },
    setSecondsPassed: (state, action) => {
      state.secondsPassed = action.payload;
    },
    setTransition: (state, action) => {
      state.animTransition = action.payload;
    },
    setAnimTimerID: (state, action) => {
      state.animTimerId = action.payload;
    },
  },
});

export const {
  setVisibility,
  setPopupMessageVisibility,
  setPopupMessageTimerID,
  setIsEverOpened,
  setStartTime,
  setSecondsPassed,
  setTransition,
  setAnimTimerID,
} = chatbotVisibility.actions;

export default chatbotVisibility.reducer;
